import { Card, Row, Table } from "antd";
import { Header } from "./components/Header";
import { useFetchDataCount } from "../../../../../lib/hooks/useDefaultFetchDataCount";
import IncidentReportsService from "../../../../../services/incidentReports";
import { useFetchData } from "../../../../../lib/hooks/useDefaultFetchData";
import { useTableColumns } from "./hooks/useTableColumns";
import { TablePagination } from "../../../../../components/TablePagination";
import { useCallback, useMemo } from "react";
import { useOpenSidebar } from "./hooks/useOpenSidebar";
import { createPortal } from "react-dom";
import { useDefualtOnRow } from "../../../../../lib/hooks/useDefaultOnRow";
import "./styles.scss";

type IncidentReportsProps = {
  id: string;
  type: 1 | 2;
  entryNumber: number | undefined;
};

export const IncidentReports = ({
  id,
  type,
  entryNumber,
}: IncidentReportsProps) => {
  const initialRequest = useMemo(
    () => (type === 1 ? { contractId: id } : { customerId: id }),
    [id, type],
  );

  const {
    request,
    isLoading: isCountLoading,
    total,
    fetchCount,
    onPageChange,
  } = useFetchDataCount<any>(IncidentReportsService, initialRequest, [""], 50);

  const { data, isLoading, fetchData } = useFetchData<any, any>(
    IncidentReportsService,
    request,
  );

  const reloadData = useCallback(() => {
    fetchData();
    fetchCount();
  }, [fetchCount, fetchData]);

  const { sidebar, item, setItem } = useOpenSidebar(
    type,
    entryNumber,
    reloadData,
  );

  const { onRow } = useDefualtOnRow((id: string) => setItem(id));

  const { columns } = useTableColumns(type, reloadData);

  return (
    <Row className="d-block py-6 px-8 h-100 card-table">
      <Card className="w-100 h-100">
        <Header id={id} type={type} setItem={setItem} />
        <Row className="w-100 pt-6 d-block card-table__body">
          <Table
            dataSource={data}
            columns={columns}
            loading={isLoading}
            pagination={false}
            rowKey="id"
            className="w-100 h-100 small-table fillable-forms__table"
            onRow={onRow}
          />
          {total > 0 && (
            <TablePagination
              isTotalLoading={isCountLoading}
              total={total}
              currentPage={request.pageNumber}
              onPageChange={onPageChange}
              pageSize={request.pageSize}
            />
          )}
        </Row>
      </Card>

      {item !== undefined && createPortal(sidebar, document.body)}
    </Row>
  );
};
